// Which regions support the 「藏照片」(photo-hunt reward) flow.
//   - ruifang: 正式活動的藏照片區
//   - taipei : 測試用(大同整區是測試區;活動前整區會被移除)
// Shared by _PinForm (placement checkbox) + MapMark/_PinEditPanel
// (existing-pin reward toggle) so the region rule lives in ONE place.
export const REWARD_REGION_IDS = new Set(["ruifang", "taipei"]);

export function isRewardRegion(regionId: string): boolean {
  return REWARD_REGION_IDS.has(regionId);
}
